import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

initComponent('.js-ff-service-cards', section => {
  const slider = section.querySelector('.js-ff-service-cards-swiper')
  const prevEl = section.querySelector('.js-slider-prev')
  const nextEl = section.querySelector('.js-slider-next')
  const slidesCount = section.querySelectorAll('.js-slide').length

  const swiper = new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: slidesCount > 1 ? 1.345 : 1,
    spaceBetween: 16,
    slidesPerGroup: 1,
    slidesOffsetBefore: slidesCount > 1 ? 16 : 0,
    slidesOffsetAfter: slidesCount > 1 ? 16 : 0,
    freeMode: false,
    navigation: {
      prevEl,
      nextEl
    },
    breakpoints: {
      1024: {
        slidesPerView: slidesCount > 3 ? 3 : slidesCount,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        spaceBetween: 32,
      }
    }
  })

  return {
    unload() {
      swiper.destroy()
    }
  }
})
